export default {
    watch: {
        useFakeApi: {
            handler(newVal) {
                this.initialConfig();
            },
            immediate: true
        }
    },
}